import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild, SimpleChanges, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import * as _ from 'lodash';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TabViewModule } from 'primeng/tabview';
import { AppIcons } from '../../../../shared/app.icons';
import { AppSettings } from '../../../../shared/app.settings';
import { MITableComponent } from '../../../../shared/components/mi-table/mi-table.component';
import type { Country } from '../../../../shared/models/country';
import type { Language } from '../../../../shared/models/language';
import { CommonBindingDataService } from '../../../../shared/services/common-binding-data.service';
import { ConfigService } from '../../../../shared/services/config.service';
import type { EntityCountsResponse, EntityList } from '../../../../shared/models/entity.models';
import type { ListResponse } from '../../../../shared/models/listResponse.models';
import { PermissionAccessService } from 'app/modules/shared/services/permission-access.service';
import { LoaderService } from 'app/modules/shared/components/loader/loader.service';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { RestApiService } from 'app/modules/shared/services/rest-api.service';
import { AccessProviderDirective } from 'app/modules/shared/directives/access-provider.directive';
import { AddProtocolSiteComponent } from './add-protocol-site/add-protocol-site.component';
@Component({
  selector: 'app-sites',
  templateUrl: './sites.component.html',
  styleUrl: './sites.component.scss',
  standalone: true,
  imports: [TabViewModule, TranslateModule, MITableComponent, BreadcrumbModule, AddProtocolSiteComponent,
    ButtonModule, DialogModule, AccessProviderDirective]
})
export class SitesComponent implements OnInit, OnChanges {
  @ViewChild('uploader', { static: true }) uploader: ElementRef<HTMLElement>;
  @ViewChild(MITableComponent) tableRef: MITableComponent;
  @ViewChild('addProtocolSite') addProtocolSite: AddProtocolSiteComponent;
  @Input() isActive: boolean = false;
  @Input() isSiteReady: boolean = false;
  @Input() siteEntityId: string;
  @Input() isAllowToAddProduct: boolean = false;
  @Input() isChangeReasonNotRequired: boolean = false;
  @Input() isEditNotAllowed: boolean = false;
  @Input() isEditNotAllowedSpecificStatus: boolean = false;
  @Output() saveSuccess = new EventEmitter<void>();

  miIcons = AppIcons;
  activeIndex: number = 0;
  isLoading = true;
  filterAvailableColumns = [];
  cols = [];
  moduleName = AppSettings.ENTITY_CODE.PROTOCOL_SITE;
  filterList;
  btnLabel: string;
  items: MenuItem[] | undefined;
  isShowMenu: boolean = true;
  attributeLabels = {};
  filterAttributeLabels = {};
  listColumns: any;
  allColumns: any;
  pagination: any;
  totalRecords: number = 0;
  tableData: any = [];
  buttons: any[] = [];
  country: Country;
  language: Language;
  entityCount: EntityCountsResponse;
  itemsPerPage: number;
  entityData: EntityList = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: "",
    filters: [],
    countryCode: '',
    deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
    forTenantCode: "",
    actionStatus: ''
  };
  routePath: MenuItem[] = [];
  deleteSiteMsg: string;
  deleteSiteHeaderMsg: string;
  showMenu: boolean = false;
  moduleHeaderSecondaryBtnMenuItems: MenuItem[] = [];
  filterFieldsArray: any[];
  isReady: boolean = false;
  attributeData: any;
  data;
  rowItems: MenuItem[] | undefined;
  bulkSelectionsItems: MenuItem[] | undefined;
  currentRow;
  visiblePrintLabel: boolean = false;
  showBulkUpdateDialog: boolean = false;
  visible: boolean = false;
  bulkUpdateHeader;
  reviewHeader: any;
  btnUpdate: any;
  entityCreatedAtAttributeId;
  regionGeofences: any = [];
  zoneIds: any = [];
  isEntity = false;
  showAddDialog: boolean = false;
  showAddProtocolSiteDialog: boolean = false;
  siteId: string;
  trialId: string;
  siteStatusAttributeId: string;
  headerLabel: string;
  attributeEntityId;
  activePreset;

  constructor(
    private entityService: EntityService,
    private cs: CommonBindingDataService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private messageService: MessageService,
    private actRoute: ActivatedRoute,
    private metaDataService: MetaDataService,
    private restApiService: RestApiService,
    private configService: ConfigService,
    private permissionAccessService: PermissionAccessService,
    private cd: ChangeDetectorRef,
    private loaderService: LoaderService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(param => {
      this.trialId = param?.id
    });
    this.initializeLabels();
    this.initializeRowItems();
    this.initializeModuleHeaderSecondaryBtnMenuItems();
    this.initializeOtherVariablesAndAPI();
    this.getMetaData();
    if (this.isAllowToAddProduct) {
      this.isAllowToAddProduct = this.permissionAccessService.hasAccess('PROTOCOL_SITES', '', 'ADD', '');
    }
    this.getFilterView();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isActive && changes.isActive.currentValue === true && !this.data) {
      this.initializeLabels();
      this.initializeRowItems();
      this.initializeModuleHeaderSecondaryBtnMenuItems();
      this.initializeOtherVariablesAndAPI();
      this.getMetaData();
    }
    this.getFilterView();
  }

  getMetaData() {
    const payload = this.getMultiApiPayload();
    this.metaDataService.metaDataMultipleApi(payload).subscribe((res) => {

      const advancedFilter = JSON.parse(res.advancedFilter.responseBody);
      if (advancedFilter) {
        this.setSiteFilterView(advancedFilter);
      }


      const sort = JSON.parse(res.sort.responseBody);
      const entityCreatedAt = sort.tabs[0].groups[0].fields.find(field => field.attributeCode === AppSettings.ENTITY_CREATED_AT);
      this.entityCreatedAtAttributeId = entityCreatedAt.attributeId;
      if (this.entityCreatedAtAttributeId) {
        // this.entityData.defaultSortColumn = this.entityCreatedAtAttributeId;
        this.entityData.defaultSortType = AppSettings.DESC_SORT_ORDER;
      }

      const defaultTableView = JSON.parse(res.defaultTableView.responseBody);
      if (defaultTableView) {
        this.setSiteTableView(defaultTableView);
      }
      this.cs.applyFilterToColumn(defaultTableView, sort);
    });
  }

  private getMultiApiPayload() {
    return [
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.PROTOCOL_SITE}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.DEFAULT_SORT_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.SORT,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.PROTOCOL_SITE}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.DEFAULT_TABLE_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.DEFAULT_TABLE_VIEW,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.PROTOCOL_SITE}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.ADVANCED_FILTER,
        headers: this.restApiService.getHeaderForMultipleAPI()
      }
    ]
  }

  getFilterView() {
    this.entityService.getAttributeDefinition(AppSettings.ENTITY_CODE.PROTOCOL_SITE, AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW).subscribe(filterResponse => {
      if (filterResponse) {
        this.setSiteFilterView(filterResponse);
        const siteStatusField = filterResponse.tabs[0].groups[0].fields.find(element => element.attributeCode === 'site_status');
        if (siteStatusField) {
          this.attributeEntityId = siteStatusField.attributeId;
          const presetVal = siteStatusField.presetValues?.find(
            preset => preset.labelKey === 'Active'
          );
          this.activePreset = presetVal?.labelKey
        }
      }
    });
  }


  setSiteFilterView(advancedFilter) {
    this.filterAttributeLabels = this.cs.getAttributeLabels(advancedFilter);
    this.filterList = this.cs.getColumns(advancedFilter);
    this.filterList = _.sortBy(this.filterList, 'attributeIndex');
    this.filterList = this.filterList.filter(field => field.attributeCode !== 'site_entity_id');
    this.entityData.filters = [{
      attributeId: this.filterList.find(field => field.attributeCode === 'protocol_entity_id')?.attributeId,
      attributeValue: this.trialId
    }]
  }

  onAdd() {
    this.showAddDialog = true;
    this.headerLabel = this.cs.getLabel("protocol.lbl_add_protocol_site");
  }

  onAddProtocolSite() {
    this.showAddProtocolSiteDialog = true;
    this.headerLabel = this.cs.getLabel("protocol.lbl_add_protocol_site");
  }

  private initializeRowItems() {
    const isEdit = this.permissionAccessService.hasAccess('PROTOCOL_SITES', '', 'EDIT', '');
    const isActivate = this.permissionAccessService.hasAccess('PROTOCOL_SITES', '', 'ACTIVE', '');
    if (this.configService.isAdmin()) {
      this.rowItems = [
        ...(isEdit ? [{
          label: this.cs.getLabel('site.lbl_edit'),
          icon: `${AppIcons.EDIT_2} wh-16`,
          iconClass: 'bulk-update-icon',
          value: 'edit',
          command: () => {
            this.update();
          }
        }] : []),
        { separator: true },
        ...(isActivate ? [{
          label: this.cs.getLabel('site.lbl_activate'),
          icon: `${AppIcons.CIRCLE_CHECKED} wh-16`,
          iconClass: 'bulk-update-icon',
          value: 'active',
          command: () => {
            this.onUpdateStatus('Active', this.cs.getLabel('site.lbl_activate'));
          }
        }] : []),
        ...(isActivate ? [{
          label: this.cs.getLabel('site.lbl_deactivate'),
          icon: `${AppIcons.ACTIVATE} wh-16`,
          iconClass: 'bulk-update-icon',
          value: 'deactive',
          command: () => {
            this.onUpdateStatus('Inactive', this.cs.getLabel('site.lbl_deactivate'));
          }
        }] : []),
      ];
    }
  }

  onUpdateStatus(status, acceptLabelText) {
    const isActive = status === 'Active';

    this.confirmationService.confirm({
      header: this.cs.getLabel(isActive ? 'prtocol_site.lbl_activate_confirmation' : 'prtocol_site.lbl_deactivate_confirmation'),
      message: this.cs.getLabel(isActive ? 'prtocol_site.msg_activate_confirmation' : 'prtocol_site.msg_deactivate_confirmation'),
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'bg-white text-color cancel',
      acceptButtonStyleClass: 'bg-red-500 delete',
      acceptLabel: acceptLabelText,
      rejectLabel: this.cs.getLabel('lbl_cancel'),
      accept: () => {
        const siteData = {
          forTenantCode: this.configService.getForTenantCode(),
          entityCode: this.moduleName,
          countryCode: this.country[0].countryCode,
          languageCode: this.language?.[0]?.langCode || 'en',
          data: [{
            attributeId: this.siteStatusAttributeId,
            attributeValue: status
          }],
          relationshipData: [],
          viewCode: AppSettings.VIEW_CODE.STATUS_UPDATE_VIEW,
        };

        this.entityService.saveAttributeData(siteData.entityCode, this.currentRow.id, siteData).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: this.cs.getLabel('prtocol_site.lbl_status_updated_successfully'),
            });
            setTimeout(() => {
              this.searchEntity();
            }, 300);
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: this.cs.getLabel('site.lbl_failed_status')
            });
          }
        });
      },
      reject: () => {
      }
    });
  }

  private initializeLabels() {
    this.entityData.forTenantCode = this.configService.getForTenantCode();
    this.routePath = [{ label: "Sites", routerLink: 'app/sites' }];
    this.headerLabel = this.siteId ?
      this.cs.getLabel("protocol.lbl_edit_protocol_site") :
      this.cs.getLabel("protocol.lbl_add_protocol_site");
  }

  private initializeOtherVariablesAndAPI() {
    this.btnLabel = this.cs.getLabel('Add Site');
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
    this.deleteSiteMsg = this.cs.getLabel('site.message.confirm_delete_msg');
    this.deleteSiteHeaderMsg = this.cs.getLabel('site.message.confirm_delete_header');
  }

  setSiteTableView(res) {
    this.isLoading = false;
    this.data = res;
    this.attributeLabels = this.cs.getAttributeLabels(this.data);
    this.allColumns = this.cs.getColumns(this.data);
    this.siteStatusAttributeId = this.allColumns.find(column => column.attributeCode === 'site_status')?.attributeId;
    this.allColumns = this.allColumns.filter(column => column.attributeCode !== 'site_entity_id');
    this.searchEntity();
    this.allColumns?.forEach((key, index) => {
      this.allColumns[index] = key;
      this.allColumns[index].field = key.attributeCode;
      this.allColumns[index].header = key.attributeCode === 'upload_document'
        ? 'Document'
        : this.cs.getLabelValue(
            `protocol_site.fields.${key.attributeCode}.label`,
            this.attributeLabels,
            key.attributeCode
          );
    });
    this.filterAvailableColumns = _.clone(this.allColumns);
  }

  searchEntity() {
    try {
      this.loaderService.show();
      this.entityData.countryCode = AppSettings.HEADER_COUNTRY_CODE;
      // this.entityData.filters = [{ attributeId: this.attributeEntityId, attributeValue: [this.activePreset] }];
      this.entityService.searchEntity(AppSettings.ENTITY_CODE.PROTOCOL_SITE, this.entityData, false)
        .subscribe({
          next: (res: ListResponse) => {
            this.isSiteReady = true;
            if (!res?.data?.length) {
              this.tableData = [];
              this.totalRecords = 0;
              return;
            }
            this.listColumns = res.data[0]?.values || {};
            this.pagination = res.pagination;
            this.totalRecords = res.count || 0;
            this.tableData = [];

            this.tableData = res.data.map(data => ({
              id: data.id,
              ...(data.values || {}),
              ...data.relatedData?.reduce((acc, item) => ({
                ...acc,
                ...(item.values || {})
              }), {})
            }));

            this.fetchDocumentSignedUrls();
          },
          error: () => {
            this.tableData = [];
            this.totalRecords = 0;
          },
          complete: () => {
            this.loaderService.hide();
          }
        });
    } catch (error) {
      this.loaderService.hide();
      this.tableData = [];
      this.totalRecords = 0;
    }
  }

  onSortData(sortColumnDetails) {
    this.entityData.defaultSortColumn = sortColumnDetails.attributeId;
    this.entityData.defaultSortType = (sortColumnDetails.sortOrder === 1) ? AppSettings.ASC_SORT_ORDER : AppSettings.DESC_SORT_ORDER;
    this.searchEntity();
  }


  onPageChange(event) {
    this.entityData.offset = event?.first;
    this.entityData.limit = event?.rows;
    this.searchEntity();
  }

  itemPerPageChange(event) {
    this.itemsPerPage = event;
    this.entityData.limit = this.itemsPerPage;
    this.searchEntity();
  }

  onFilterValueChange(event) {
    const vData = event;
    this.entityData.filters = [];
    for (const [key, value] of Object.entries(vData)) {
      const attributeValue = value;
      if (attributeValue) {
        this.entityData.filters.push({
          attributeCode: key,
          attributeValue
        });
      }
    }
    this.entityData.filters = _.filter(_.uniq(this.entityData.filters, (item) => {
      if (item.attributeValue.length > 0) {
        return item.attributeCode;
      }
    }), (element) => {
      if (element.attributeValue.length > 0) {
        return true;
      }
      return false;
    });
    this.entityData.offset = event.first;
    this.entityData.filters = this.cs.mapAttributeIds(this.entityData.filters, this.filterList, 'filter');
    this.searchEntity();
  }

  onSearchValueChanges(event) {
    this.entityData.searchStr = event;
    this.searchEntity();
  }

  getEntityCount() {
    const res = {
      "tenantId": "2",
      "entityCode": "site",
      "counts": {
        "UNASSIGNED": 48,
        "ALL": 84,
        "ASSIGNED": 27,
        "DELETED": 9
      }
    }

    if (res?.counts) {
      res.counts.ALL = res.counts.ALL - res.counts.DELETED;
    }
    this.entityCount = res;
  }

  setCurrentRowData(event) {
    this.currentRow = event;

    if (event.deleted) {
      this.rowItems.forEach(item => {
        if (!item.separator) {
          item.disabled = true;
        }
      });
      return;
    }
    this.rowItems.forEach(item => {
      switch (item.value) {
        case 'edit':
          item.disabled = this.isEditNotAllowed || (event.site_status as { Rejected: string })?.Rejected === 'Rejected' || (event.site_status as { Archive: string })?.Archive === 'Archived' || event.site_status?.Inactive === 'Inactive';
          break;
        case 'active':
          item.disabled = event.site_status?.Active === 'Active' || this.isEditNotAllowed || (event.site_status as { Rejected: string })?.Rejected === 'Rejected' || (event.site_status as { Archive: string })?.Archive === 'Archived' || (event.site_status as { Requested: string })?.Requested === 'Requested';
          break;
        case 'deactive':
          item.disabled = event.site_status?.Inactive === 'Inactive' || this.isEditNotAllowed || (event.site_status as { Rejected: string })?.Rejected === 'Rejected' || (event.site_status as { Archive: string })?.Archive === 'Archived' || (event.site_status as { Requested: string })?.Requested === 'Requested';
          break;
      }
    });
  }

  update() {
    this.onUpdateSite(this.currentRow.id);
  }

  onUpdateSite(siteId) {
    this.siteId = siteId;
    this.showAddProtocolSiteDialog = true;
    this.headerLabel = this.cs.getLabel("protocol.lbl_edit_protocol_site")
  }

  openAddDialog() {
    if (this.isSiteReady) {
      this.showAddProtocolSiteDialog = true;
    }
  }

  onSaveSuccess() {
    this.showAddProtocolSiteDialog = false;
    this.siteId = null;
    this.searchEntity();
    this.saveSuccess.emit();
  }

  private fetchDocumentSignedUrls() {
    const fileIds: string[] = this.tableData
      .map(row => row.upload_document?.[0])
      .filter(id => !!id);

    if (!fileIds.length) return;

    const payload = {
      forTenantCode: this.configService.getForTenantCode(),
      uploadType: AppSettings.DOCUMENTS_TYPE.DOCUMENT,
      fileIds
    };

    this.restApiService.post(
      'get site document details',
      `${this.configService.getLoggedInTenantCode()}/api/v1/files/details`,
      payload
    ).subscribe({
      next: (fileDetails: any[]) => {
        const signedUrlMap = new Map<string, string>();
        fileDetails.forEach(f => {
          if (f.fileId) signedUrlMap.set(f.fileId, f.signedUrl);
          if (f.resourceId) signedUrlMap.set(f.resourceId, f.signedUrl);
        });
        this.tableData = this.tableData.map(row => ({
          ...row,
          _docSignedUrl: signedUrlMap.get(row.upload_document?.[0]) || null
        }));
      }
    });
  }

  private initializeModuleHeaderSecondaryBtnMenuItems() {
    // Initialize secondary button menu items if needed
  }

  onDialogVisibleChange(visible: boolean) {
    if (!visible && this.addProtocolSite) {
      this.addProtocolSite.onCancel();
    }
  }

  onDialogClose() {
    if (this.addProtocolSite) {
      this.addProtocolSite.onCancel();
    }
    this.showAddProtocolSiteDialog = false;
    this.siteId = null;
    setTimeout(() => {
      this.searchEntity();
    }, 100);
  }
}


